import React, { forwardRef } from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  icon?: React.ReactNode;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, icon, className = '', ...props }, ref) => {
    const baseInputClass = "w-full border rounded-lg px-3 py-2 text-sm text-gray-700 h-10 focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary transition-all disabled:bg-gray-50 disabled:text-gray-500";
    const errorClass = error ? "border-red-500 focus:ring-red-200" : "border-gray-300";
    const iconClass = icon ? "pl-9" : "";

    return (
      <div className="w-full">
        {label && (
          <label className="block text-gray-600 text-sm font-bold mb-1">
            {label} {props.required && <span className="text-red-500">*</span>}
          </label>
        )}
        <div className="relative">
          {icon && (
            <div className="absolute left-3 top-2.5 text-gray-400 pointer-events-none">
              {icon}
            </div>
          )}
          <input
            ref={ref}
            className={`${baseInputClass} ${errorClass} ${iconClass} ${className}`}
            {...props}
          />
        </div>
        {error && <p className="text-red-500 text-xs mt-1">{error}</p>}
      </div>
    );
  }
);

Input.displayName = 'Input';